import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { AsyncLinks } from '../actions/book/AsyncLinks';
import { ItemActionType } from './SetMarketplaceAction';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  togglePackaged?: () => void;
  size: 'small' | 'normal';
  packaged: boolean;
  actions: ItemActionType[];
}

export default function MarketplaceActionsDispatched(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (props.actions.length === 0) {
    return null;
  }

  if (props.size === 'normal') {
    return (
      <AsyncLinks
        tag=""
        links={[
          props.actions.includes('MARK-AS-DISPATCHED') && {
            Type: 'MARKDISPATCHED_ONCLICK',
            Label: 'Notify Marketplace',
            Href: null,
            OnClick: () => {},
            Checked: true,
            Disabled: true
          },
          props.actions.includes('MARK-AS-PACKAGED') && {
            Type: 'MARKPACKAGED_ONCLICK',
            Label: 'Mark as Packaged',
            Href: null,
            OnClick: props.togglePackaged,
            Checked: props.packaged
          }
        ]}
        variant="list"
        match={null}
        title={null}
      />
    );
  }

  return (
    <>
      {props.actions.includes('MARK-AS-DISPATCHED') && (
        <P2GGrid item flexShrink={1}>
          <P2GCheckBoxLegacy
            checked={true}
            id="Dispatched"
            disabled={true}
            onChange={() => {}}
            label={
              <P2GText variant="body2" colour="primary">
                {t('NOTIFY_MARKETPLACE_INPUT_LABEL', { defaultValue: 'Notify Marketplace' })}
              </P2GText>
            }
            labelPlacement="end"
            variant="primary"
            error={false}
          />
        </P2GGrid>
      )}
      {props.actions.includes('MARK-AS-PACKAGED') && (
        <P2GGrid item flexShrink={1}>
          <P2GCheckBoxLegacy
            checked={props.packaged}
            id="Packaged"
            onChange={props.togglePackaged}
            label={
              <P2GText variant="body2" colour="primary">
                {t('PACKAGED_INPUT_LABEL', { defaultValue: 'Packaged' })}
              </P2GText>
            }
            labelPlacement="end"
            variant="primary"
            error={false}
          />
        </P2GGrid>
      )}
    </>
  );
}
